import React from 'react'
import styled from 'styled-components'
import dayjs from 'dayjs';
import { TextField } from '@mui/material'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const ModalBox = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 25vw;
  height: 50vh;
  background: white;
  border: 2px solid #000;
  box-shadow: 24px;
  padding-left: 1vw;
  padding-right: 1vw;

  padding-top: 1vh;
  padding-bottom: 1vh;

  display: flex;
  flex-direction: column;
`

const ModalTitleBox = styled.div`
  font-size: 2rem;

  display: flex;
  justify-content: space-between;
`

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  justify-content: space-between;
`

const FieldContainer = styled.div`
  display: flex;

  > * {
    flex: 1;
  }
  
  gap: 1vw;
  margin-top: 1vw;
`
const SaveBox = styled.div`
  display: flex;
`

const SaveButton = styled.button`
  width: 100px;

  border: 2px solid tomato;
  border-radius: 3px;
  background: white;
  font-weight: bold;
  color: tomato;

  margin-top: 1vh;

  &:hover{
    background: tomato;
    color: white;
  }

  padding: 5px 0vw 5px 0vw;
`

const CancelButton = styled.button`
  width: 100px;

  border: 2px solid darkgrey;
  border-radius: 3px;
  background: white;
  font-weight: bold;
  color: darkgrey;

  margin-top: 1vh;

  &:hover{
    background: #F8F8F8;
  }

  margin-left: 5px;
  padding: 5px 0vw 5px 0vw;
`

const ErrorMessageBox = styled.div`
  color: #e1341e;
  font-weight: bold;
  margin-top: 1vh;

  &.SUCCESS {
    color: #31b76b;
  }
`

const theme = createTheme({
  palette: {
    primary: {
      main: '#FF6347',
    },
  },
});

export default function AllocationCreateShiftForm({ jobId, updatePage, closeModal }) {
  const [startTime, setStartTime] = React.useState(dayjs().startOf('day'));
  const [endTime, setEndTime] = React.useState(dayjs().startOf('day'));
  const [date, setDate] = React.useState(dayjs().startOf('day'))

  const [numWorkers, setNumWorkers] = React.useState(0);

  const [errorMsg, setErrorMsg] = React.useState("")

  const handleAddShiftToDB = async () => {
    try {

      if (numWorkers === 0) {
        setErrorMsg("Number of workers cannot be 0")
        throw new Error("invalid number of workers");
      }

      const res = await fetch(`/api/allocations/jobs/${jobId}/shifts/createShift`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          startTime: startTime,
          endTime: endTime,
          date: date,
          numWorkers: parseInt(numWorkers)
        })
      });
  
      const data = await res.json();
      setErrorMsg("Successfully created shift")
      updatePage();
    } catch (error) {
      console.error("Error:", error)
    }
  };

  return (
    <ModalBox>
      <ModalTitleBox>
        <div>Create Shift</div>
        <IconButton onClick={() => { closeModal() }}>
          <CloseIcon sx={{ fontSize: "2rem", color: "tomato" }} />
        </IconButton>
      </ModalTitleBox>
      <ModalBody>
        <ThemeProvider theme={theme}>
          <div>
            <FieldContainer >
              <TextField 
                label="Workers" 
                variant="outlined"
                value ={numWorkers}
                onChange={(e)=>{setNumWorkers(e.target.value)}}
              />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker 
                label="Date" 
                format="DD/MM/YYYY" 
                value={date}
                onChange={(newValue) => setDate(newValue)}
                />
              </LocalizationProvider>
            </FieldContainer>
            <hr/>
            <FieldContainer >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimePicker 
                  label="Start Time"
                  value={startTime}
                  onChange={(newValue) => setStartTime(newValue)}
                />
              </LocalizationProvider>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimePicker 
                label="End Time"
                value={endTime}
                onChange={(newValue) => setEndTime(newValue)}
                />
              </LocalizationProvider>
            </FieldContainer>

            {
              errorMsg === "Successfully created shift" ?
              <ErrorMessageBox className ="SUCCESS">{errorMsg} </ErrorMessageBox>
              :
              <ErrorMessageBox >{errorMsg} </ErrorMessageBox>
            }
          </div>
        </ThemeProvider>

        <SaveBox>
          <SaveButton onClick={()=>handleAddShiftToDB()}>Add</SaveButton>
          <CancelButton onClick={()=>{closeModal()}}>Cancel</CancelButton>
        </SaveBox>

      </ModalBody>
    </ModalBox>
  )
}
